package com.daytimegaming.ourdailyfinances.domain.repository

import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.Investments
import com.daytimegaming.ourdailyfinances.domain.model.PortfolioHistory
import com.daytimegaming.ourdailyfinances.domain.model.RecurringTransactionStream
import com.daytimegaming.ourdailyfinances.domain.model.Transaction
import com.daytimegaming.ourdailyfinances.domain.model.SecurityPerformance
import com.daytimegaming.ourdailyfinances.domain.model.PlaidPricesSync
import kotlinx.coroutines.flow.StateFlow

interface TransactionRepository {
    val transactions: StateFlow<Response<List<Transaction>>>
    val recurringTransactions: StateFlow<Response<List<RecurringTransactionStream>>>
    val investments: StateFlow<Response<Investments?>>
    val portfolioHistory: StateFlow<Response<PortfolioHistory?>>
    suspend fun refresh()
    suspend fun refreshRecurringTransactions()
    suspend fun refreshPortfolioHistory()
    suspend fun updateTransactionCategory(transactionId: String, detailed: String?): Response<Transaction>
    suspend fun getSecurityPerformance(dashboardId: String? = null, accountId: String? = null): Response<SecurityPerformance>
    suspend fun syncInvestmentPrices(source: String): Response<PlaidPricesSync>
}
